import { resolveWojewodztwoCode } from './wojewodztwa'

export const EMPTY_STRUCTURED = {
	wojewodztwo: '',
	miasto: '',
	kodPocztowy: '',
	ulica: '',
	numer: '',
}

function getComponentText(component, preferShort = false) {
	if (!component) return ''
	if (preferShort && component.shortText) return component.shortText
	return component.longText ?? component.long_name ?? component.shortText ?? component.short_name ?? ''
}

function findAddressComponent(components, types) {
	if (!Array.isArray(components)) return null
	const wanted = Array.isArray(types) ? types : [types]
	return components.find((component) => wanted.some((type) => component.types?.includes(type)))
}

export function parsePolishAddress(addressComponents) {
	const wojewodztwo = getComponentText(
		findAddressComponent(addressComponents, 'administrative_area_level_1'),
	)
	const miasto =
		getComponentText(findAddressComponent(addressComponents, ['locality', 'postal_town'])) ||
		getComponentText(findAddressComponent(addressComponents, 'sublocality_level_1'))
	const kodPocztowy = getComponentText(findAddressComponent(addressComponents, 'postal_code'))
	const ulica = getComponentText(findAddressComponent(addressComponents, 'route'))
	const numer = getComponentText(findAddressComponent(addressComponents, 'street_number'))

	return { wojewodztwo, miasto, kodPocztowy, ulica, numer }
}

export function toSelectedPlace(place) {
	if (!place?.location) return null

	return {
		placeId: place.id,
		formattedAddress: place.formattedAddress,
		lat: place.location.lat(),
		lng: place.location.lng(),
		addressComponents: place.addressComponents,
		structured: parsePolishAddress(place.addressComponents),
	}
}

export function buildAddressFieldsFromPlace(place) {
	if (!place) return null

	const streetLine = [place.structured?.ulica, place.structured?.numer]
		.filter(Boolean)
		.join(' ')
		.trim()

	const wojewodztwo = resolveWojewodztwoCode(place.structured?.wojewodztwo)

	return {
		ulica: streetLine || place.formattedAddress || '',
		kod_pocztowy: place.structured?.kodPocztowy || '',
		miasto: place.structured?.miasto || '',
		...(wojewodztwo ? { wojewodztwo } : {}),
		g_placeid: place.placeId || '',
		g_lat: place.lat ?? '',
		g_long: place.lng ?? '',
	}
}
